import { RouteConfig } from "vue-router";
import { api } from "./api";
import { notFound } from "./notFound";

export const error = (): Array<RouteConfig> => [...api(), ...notFound()];
